/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

/** @default "VARIANT_UNKNOWN" */
export type DashboardVariant = "VARIANT_UNKNOWN" | "CUSTOM" | "LIGHT" | "PRO";

export interface DataPoint {
  /** Label for the data point. */
  label?: string;
  /** Time for which the statistics data points are aggregated. Timestamp is returned in RFC3339 format. Example `2018-09-08T22:47:31Z07:00`. */
  timestamp?: string;
  /**
   * Value of the data point.
   * @format float
   */
  value?: number;
}

/** Response with the dashboard reference. */
export interface GetDashboardResponse {
  /**
   * determines if the dashboard is enabled in the configuration
   * if false, the other fields are empty
   */
  enabled?: boolean;
  /** Datetime in RFC3339 format with timestamp of URL expiration. */
  expires_at?: string;
  /** URL to Metabase dashboard of given type, that can be embedded in iframe. */
  iframe_url?: string;
  variant?: DashboardVariant;
}

/** Response with the statistics. */
export interface GetStatisticsResponse {
  /** Collection of the statistics of the given type containing the data points with timestamps. */
  statistics?: Statistics;
}

export interface ListEnabledDashboardsResponse {
  dashboards?: string[];
}

/** The collection of the data points of the given type. */
export interface Statistics {
  /** Timestamped values of the statistics in the last 24 hours interval. The distance between the data points is 5 minutes. */
  data_points?: DataPoint[];
  /** Human-readable description of the statistics. */
  description?: string;
  /** Name of the statistics. */
  name?: string;
}

export interface Status {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/dashboard" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title dashboard API
 * @version 1.0
 * @baseUrl /v1/dashboard
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  dashboard = {
    /**
     * No description
     *
     * @name DashboardGetDashboard
     * @summary Returns the reference to Metabase dashboard that can be embedded in iframe.
     * @request GET:/dashboard/{site_id}/get
     * @secure
     */
    dashboardGetDashboard: (
      siteId: string,
      query: {
        /** Type of the dashboard URL to fetch. */
        type?: string;
        /** @default "UNKNOWN" */
        dashboard_type: "UNKNOWN" | "TRACKING" | "CHECKOUT" | "TRANSPORT_ADMINISTRATION" | "CARRIER_REPORTS";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDashboardResponse, Status>({
        path: `/dashboard/${siteId}/get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  enabledDashboards = {
    /**
     * No description
     *
     * @name DashboardListEnabledDashboards
     * @summary Returns the config details for all of the dashboards
     * @request GET:/enabled_dashboards/{site_id}
     * @secure
     */
    dashboardListEnabledDashboards: (siteId: string, params: RequestParams = {}) =>
      this.request<ListEnabledDashboardsResponse, Status>({
        path: `/enabled_dashboards/${siteId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  statistics = {
    /**
     * No description
     *
     * @name DashboardGetStatistics
     * @summary Returns the array of statistics with the statistics names and data points.
     * @request GET:/statistics/{site_id}/get
     * @secure
     */
    dashboardGetStatistics: (
      siteId: string,
      query: {
        /** Type of the statistics to fetch. */
        type?: string;
        /** Country of the statistics to fetch. */
        country: string;
        /** @default "UNKNOWN" */
        dashboard_type: "UNKNOWN" | "TRACKING" | "CHECKOUT" | "TRANSPORT_ADMINISTRATION" | "CARRIER_REPORTS";
      },
      params: RequestParams = {},
    ) =>
      this.request<GetStatisticsResponse, Status>({
        path: `/statistics/${siteId}/get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
